<app-text [alias]="'view_log_component'"></app-text>
<div *ngIf="criteria">
    <app-table-filter [tableName]="tableName" [filterItems]="filters"></app-table-filter>
    <app-table
            [tableName]="tableName"
            [baseUrl]="baseUrl"
            [searchCriteria]="criteria"
            [columns]="columns"></app-table>
</div>
